<template>
  <header class="app-header">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/images/logo.png" alt="FUSING">
          <span class="logo-text">FUSING</span>
        </router-link>
      </div>
      <nav class="main-nav">
        <ul>
          <li><router-link to="/">首页</router-link></li>
          <li><router-link to="/high-precision-enhancement">高精度增强定位</router-link></li>
          <li><router-link to="/atmospheric-environmental-monitoring">大气环境监测</router-link></li>
          <li><router-link to="/tomography">多源融合</router-link></li>
          <li><router-link to="/data-platform">数据展示</router-link></li>
          <li><router-link to="/special-events">特殊事件</router-link></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style scoped>
.app-header {
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo a {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo img {
  height: 40px;
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: var(--primary-color);
}

.main-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.main-nav a {
  font-weight: 500;
  font-size: 16px;
  padding: 8px 0;
  position: relative;
}

.main-nav a:hover {
  color: var(--secondary-color);
}

.main-nav a.router-link-active {
  color: var(--secondary-color);
}``

.main-nav a.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--secondary-color);
}

@media (max-width: 768px) {
  .main-nav ul {
    gap: 15px;
  }
  
  .main-nav a {
    font-size: 14px;
  }
  
  .logo-text {
    font-size: 20px;
  }
}
</style>